import React from "react";
import {Grid, Typography} from "@mui/material";

import icon from '../assets/icon.png';

const BreakElement = () => <div>
    <br/>
    <br/>
</div>

export default () => {
    return <Grid container sx={{ width: "100%", paddingTop: "20px" }}>
        <Grid item xs={12}>
            <Typography variant="h3" component="div" align={"center"} justifyContent={"center"} gutterBottom>Privacy Policy</Typography>
        </Grid>
        <Grid item xs={12} textAlign={"center"}>
            <img src={icon} style={{ maxWidth: "200px", width: "100%", borderRadius: "20px" }}/>
        </Grid>
        <Grid item xs={0} md={2}></Grid>
        <Grid item xs={12} md={8} sx={{paddingLeft: "10px", paddingRight: "10px"}}>
            <Typography variant="subtitle1" component="div" align={"left"} justifyContent={"center"}>
                <b>Last updated: (Aug 01, 2022)</b>
                <BreakElement/>
                OnLogixs ("us", "we", or "our") operates https://onlogixs.com (the "Site"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site.
                <BreakElement/>
                We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.
                <BreakElement/>
                <b>Information Collection And Use</b>
                <BreakElement/>
                While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name ("Personal Information").
                <BreakElement/>
                <b>Log Data</b>
                <BreakElement/>
                Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data").
                <BreakElement/>
                This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.
                <BreakElement/>
                In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this …
                <BreakElement/>
                <b>Communications</b>
                <BreakElement/>
                We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that ...
                <BreakElement/>
                <b>Cookies</b>
                <BreakElement/>
                Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.
                <BreakElement/>
                Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.
                <BreakElement/>
                <b>Security</b>
                <BreakElement/>
                The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
                <BreakElement/>
                <b>Changes To This Privacy Policy</b>
                <BreakElement/>
                We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.
                <BreakElement/>
                If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.
                <BreakElement/>
                <b>Contact Us</b>
                <BreakElement/>
                If you have any questions about this Privacy Policy, please contact us: sergii@onlogixs.com
                <BreakElement/>
            </Typography>
        </Grid>
        <Grid item xs={0} md={2}></Grid>
        <Grid item xs={12} textAlign={"center"}>
            Ⓒ {new Date().getFullYear()} OnLogixs
            <BreakElement/>
        </Grid>
    </Grid>;
}
